__turbopack_context__.v({
  "ctaButton": "MakeWebsiteLiveSection-module__KulJ5a__ctaButton",
  "heroSection": "MakeWebsiteLiveSection-module__KulJ5a__heroSection",
  "subtitle": "MakeWebsiteLiveSection-module__KulJ5a__subtitle",
  "title": "MakeWebsiteLiveSection-module__KulJ5a__title",
});
